// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"ReleaseNoteContent_contentWrapper__SNl0R","content":"ReleaseNoteContent_content__rZP9C"};